(function(){
  'use strict';

  var wrapperId = 'google-merchantwidget-iframe-wrapper';

  function removeFloatingWidget(){
    var wrapper = document.getElementById(wrapperId);
    if(wrapper && wrapper.parentNode) wrapper.parentNode.removeChild(wrapper);
  }

  removeFloatingWidget();

  if('MutationObserver' in window){
    new MutationObserver(removeFloatingWidget).observe(document.documentElement,{
      childList:true,
      subtree:true
    });
  }

  window.setTimeout(removeFloatingWidget,250);
  window.setTimeout(removeFloatingWidget,1000);
  window.setTimeout(removeFloatingWidget,3000);
})();
